import React from "react";
import PropTypes from "prop-types";
import { InfoTooltipIcon } from "wm-graphics";
import { Flyout } from "../Flyout/Flyout";
import "./InfoFlyout.scss";

export class InfoFlyout extends React.Component {
  static defaultProps = {
    showArrow: true,
    offSetY: 10,
  };

  static propTypes = {
    message: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    direction: PropTypes.string,
    offSetX: PropTypes.number,
    offSetY: PropTypes.number,
    showArrow: PropTypes.bool,
  };

  constructor() {
    super();

    this.state = {
      showFlyout: false,
    };

    this.flyoutRef = React.createRef();
  }

  handleMouseOver = () => {
    this.setState({ showFlyout: true });
  };

  handleMouseLeave = () => {
    this.setState({ showFlyout: false });
  };

  render() {
    const { direction, message, offSetX, offSetY, showArrow } = this.props;
    const { showFlyout } = this.state;

    return (
      <div
        className="InfoFlyout"
        data-testid="InfoFlyout"
        ref={this.flyoutRef}
        onMouseOver={this.handleMouseOver}
        onMouseLeave={this.handleMouseLeave}
        onFocus={this.handleMouseOver}
      >
        <InfoTooltipIcon height={15} width={15} />
        {showFlyout && (
          <Flyout
            placementRef={this.flyoutRef.current}
            offSetY={offSetY}
            offSetX={offSetX}
            placement={direction}
            showArrow={showArrow}
          >
            <div className="InfoFlyout__message">{message}</div>
          </Flyout>
        )}
      </div>
    );
  }
}

export default InfoFlyout;
